import { render, staticRenderFns } from "./PreviousSeal.vue?vue&type=template&id=622186c0&scoped=true"
import script from "./PreviousSeal.vue?vue&type=script&lang=js"
export * from "./PreviousSeal.vue?vue&type=script&lang=js"
import style0 from "./PreviousSeal.vue?vue&type=style&index=0&id=622186c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622186c0",
  null
  
)

export default component.exports